module.exports = __webpack_public_path__ + "04_hige_black.ee2329ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer3/04_hige_black.png
// module id = FtZH
// module chunks = 0